import type { ReactElement } from 'react';

const isDev = import.meta.env.DEV;

export const tryRenderDevStandalonePage = async (render: (element: ReactElement) => void): Promise<boolean> => {
    if (!isDev) return false;
    if (globalThis.location.pathname !== '/design-system-usage-audit') return false;
    const { DesignSystemUsageAuditPage } = await import('./design-system-usage-audit/DesignSystemUsageAuditPage');
    render(<DesignSystemUsageAuditPage />);
    return true;
};
